import moment from 'moment'
import SystemSettingStore from '../stores/systemSetting.store'

// Looks up the historically-accurate break-the-bar threshold for an agent scope
// and week start date. Thresholds change over time; the history array in
// 'usertypes---break-the-bar-thresholds' tracks each change with a start date
// and value. Returns the most recent threshold whose start date <= startDate,
// falling back to the earliest entry if none predate it.
export const getThresholdForScope = (scope, startDate) => {
  const btb = SystemSettingStore.get('usertypes---break-the-bar-thresholds')
  if (!btb || !Array.isArray(btb[scope]?.history)) return 0

  const history = [...btb[scope].history].sort((a, b) =>
    moment(b.start, 'YYYY-MM-DD').diff(moment(a.start, 'YYYY-MM-DD'))
  )

  const applicable = history.filter(
    th => moment(startDate, 'YYYY-MM-DD').diff(moment(th.start, 'YYYY-MM-DD'), 'days') >= 0
  )

  if (!applicable.length && history.length) return parseInt(history[0]?.value) || 0
  return parseInt(applicable[0]?.value) || 0
}

export default getThresholdForScope
